import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'sonner';
import { FaWallet, FaEnvelope, FaLock } from 'react-icons/fa';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'https://dev.brdz.xyz';
const API = `${BACKEND_URL}/api`;

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const res = await axios.post(`${API}/login`, { email, password }, { withCredentials: true });
      localStorage.setItem('token', res.data.access_token);
      toast.success('Login successful!');
      
      // Check if user has already chosen custody
      const token = res.data.access_token;
      const addressRes = await axios.get(`${API}/addresses`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      
      if (addressRes.data.length > 0) {
        navigate('/dashboard');
      } else {
        navigate('/custody');
      }
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4">
      <div
        className="absolute inset-0 z-0"
        style={{
          backgroundImage: `url('https://images.unsplash.com/photo-1762279388956-1c098163a2a8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwyfHxhYnN0cmFjdCUyMGRhcmslMjBuZXR3b3JrJTIwZGF0YSUyMHZpc3VhbGl6YXRpb24lMjBiYWNrZ3JvdW5kfGVufDB8fHx8MTc2NTA3OTUxMHww&ixlib=rb-4.1.0&q=85')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          opacity: 0.15,
        }}
      />

      <div className="relative z-10 w-full max-w-md fade-in-up">
        <div className="text-center mb-8">
          <div className="flex items-center justify-center mb-4">
            <FaWallet className="text-[#ccff00] text-5xl" />
          </div>
          <h1 className="text-4xl font-extrabold tracking-tight text-white mb-2" style={{ fontFamily: 'Manrope' }}>
            Welcome Back
          </h1>
          <p className="text-[#94a3b8] text-sm uppercase tracking-widest">
            Login to your wallet
          </p>
        </div>

        <div className="bg-[#0f172a] border border-[#1e293b] p-8 backdrop-blur-sm">
          <h2 className="text-2xl font-bold text-white mb-6" style={{ fontFamily: 'Manrope' }}>
            Sign In
          </h2>

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-xs uppercase tracking-widest text-[#94a3b8] mb-2">
                Email
              </label>
              <div className="relative">
                <FaEnvelope className="absolute left-4 top-4 text-[#94a3b8]" />
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full bg-[#020617] border border-[#1e293b] text-white pl-12 pr-4 h-12 focus:border-[#ccff00] focus:ring-1 focus:ring-[#ccff00] outline-none transition-colors"
                  placeholder="you@example.com"
                  required
                  data-testid="login-email-input"
                />
              </div>
            </div>

            <div>
              <label className="block text-xs uppercase tracking-widest text-[#94a3b8] mb-2">
                Password
              </label>
              <div className="relative">
                <FaLock className="absolute left-4 top-4 text-[#94a3b8]" />
                <input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="w-full bg-[#020617] border border-[#1e293b] text-white pl-12 pr-4 h-12 focus:border-[#ccff00] focus:ring-1 focus:ring-[#ccff00] outline-none transition-colors"
                  placeholder="••••••••"
                  required
                  data-testid="login-password-input"
                />
              </div>
            </div>

            <button
              type="submit"
              disabled={loading}
              className="w-full bg-[#ccff00] text-black font-bold uppercase tracking-wider text-sm px-8 py-3 hover:bg-[#b3e600] transition-all hover:translate-x-1 hover:-translate-y-1 hover:shadow-[4px_4px_0px_0px_rgba(255,255,255,0.2)] disabled:opacity-50 disabled:cursor-not-allowed"
              style={{ fontFamily: 'Manrope' }}
              data-testid="login-submit-button"
            >
              {loading ? 'Logging in...' : 'Login'}
            </button>
          </form>

          <div className="mt-6 text-center">
            <button
              onClick={() => navigate('/register')}
              className="text-[#ccff00] hover:text-[#b3e600] text-sm transition-colors"
              data-testid="navigate-to-register-button"
            >
              Don't have an account? Register
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}